'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ../node_modules/react/react.js
// module id = 0
// module chunks = 0